import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    destroyOnClose: true,
    visible: _ctx.isOpen,
    onCancel: _ctx.handleCancel,
    zIndex: 999,
    footer: null,
    width: 900
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.view)))
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}